<template>
    <div class="checkbox-container">
        <h5 v-if="label">{{label}}</h5>

        <yoga-checkbox v-for="option in options" :option="option"
         :key="option.id" :config="config" :single="single"></yoga-checkbox>
    </div>
</template>

<script>
import YogaCheckbox from "./YogaCheckbox.vue";

export default {
  name: `CheckboxContainer`,
  components: {
    YogaCheckbox
  },
  props: {
    options: Array,
    label: String,
    config: String,
    single: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
</style>
